import React from 'react'
import SlotCards from './SlotCards'
import SlotList from './SlotList'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'

export default function MaintenanceSlotsTab ({ maintenanceSlots, boxes }) {
  const screens = useBreakpoint()

  return (
    <>
      { screens.xs && <SlotCards slots={maintenanceSlots} boxes={boxes} /> }
      { !screens.xs && <SlotList slots={maintenanceSlots} boxes={boxes} /> }
    </>
  )
}
